import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import { routes } from 'pluton-core/lib/constants/routes.constant';
import { isCostUrl, isControlUrl } from 'pluton-core/lib/utils/helpers';


class Footer extends Component {
    render() {
        const currentUrl = this.props.location.pathname;
        const classesHome = {
            'nav__item': true,
            'active': currentUrl === routes.home()
        };
        const classesCost = {
            'nav__item': true,
            'active': isCostUrl(currentUrl)
        };
        const classesControl = {
            'nav__item': true,
            'active': isControlUrl(currentUrl) || currentUrl === routes.control()
        };
        const classesAlerts = {
            'nav__item': true,
            'active': currentUrl === routes.alert()
        };
        const classesMore = {
            'nav__item': true,
            'active': currentUrl === routes.more()
        };

        return (
            <div className="nav-wrap">
                <nav className="nav">
                    <div className={classNames(classesHome)}>
                        <Link className="nav__link" to={`${routes.home()}`}>
                            <div className="nav__img nav__img--home"/>
                            <span className="nav__text">HOME</span>
                        </Link>
                    </div>
                    <div className={classNames(classesCost)}>
                        <Link className="nav__link" to={`${routes.cost()}`}>
                            <div className="nav__img nav__img--cost"/>
                            <span className="nav__text">COST</span>
                        </Link>
                    </div>
                    <div className={classNames(classesControl)}>
                        <Link className="nav__link" to={`${routes.control()}`}>
                            <div className="nav__img nav__img--control"/>
                            <span className="nav__text">CONTROL</span>
                        </Link>
                    </div>
                    <div className={classNames(classesAlerts)}>
                        <Link className="nav__link" to={`${routes.alert()}`}>
                            <div className="nav__img nav__img--alert"/>
                            <span className="nav__text">ALERTS</span>
                        </Link>
                    </div>
                    <div className={classNames(classesMore)}>
                        <Link className="nav__link" to={`${routes.more()}`}>
                            <div className="nav__img nav__img--more"/>
                            <span className="nav__text">MORE</span>
                        </Link>
                    </div>
                </nav>
            </div>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./app/components/controls/footer/Footer.jsx